<ion-header translucent>
  <ion-toolbar>
    <ion-title>{{title|translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">{{ 'btn.annull' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar animated="true" cancelButtonText="Cancella" placeholder="Cerca..." [(ngModel)]="searchText" #searchbar></ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content class="full-bg" fullscreen>
  <ion-list *ngIf="options && options.length > 0">
    <ion-item *ngFor="let item of (options | domainFilter:searchText:maxVisibleResults)" button (click)="selectOption(item.key)">{{ item.value }}</ion-item>
  </ion-list>
  <div *ngIf="options && options.length === 0" class="ion-text-center ion-margin">
    <p>{{ 'lbl.no_result_available' | translate }}</p>
  </div>
</ion-content>